import { Components, tabClasses } from '@mui/material';
import { Theme } from '@mui/material/styles';

export const MuiTabs: Components<Theme>['MuiTabs'] = {
  styleOverrides: {
    root: () => ({
      minHeight: 40,
    }),
    indicator: () => ({
      height: 4,
      borderRadius: '0 0 4px 4px',
    }),
  },
};

export const MuiTab: Components<Theme>['MuiTab'] = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      minHeight: 40,
      padding: '8px 16px',
      borderRadius: 4,
      color: theme.palette.text.primary,
      ...theme.typography.h4,
      textTransform: 'none',
      [`&.${tabClasses.selected}`]: {
        color: theme.palette.text.primary,
      },
    }),
  },
};
